<template>
  <div>
    <new-maintainInfo showpages="maintainInfo"></new-maintainInfo>
  </div>
</template>

<script>
import backgroundDetail from '../../../components/backgroundDetail.vue' 
/**
 *@ClassName:repoInfoBD
 *@Description:报事信息-后台详情
 *@author:宋莎
 *@Copyright:格众科技
 *@date:2020-04-22
 */
export default {
  components: {
    'new-maintainInfo': backgroundDetail 
  },
  data () {
    return {}
  },
  computed: {},
  watch: {},
  methods: {
  
},
}
</script>
<style lang='scss'>
 
</style>
